var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle108(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "307.2840527735794 86.66978426118106 25.736150500316853 29.838081336844468",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M323.59,92.52c2.37-2.62,3.58-2.47,4.58.53.5,1.51.86,3.14.85,4.72-.02,2.62-.22,5.27-.65,7.86-.6,3.68-3.3,6.1-7.13,6.77-3.19.56-7-1.11-8.76-3.86-3.29-5.11.64-14.89,6.53-16.28.43-.1.87-.23,1.3-.2,1.01.09,2.02.27,3.28.45ZM323.73,100.76c.15-2.36-1.74-3.68-3.47-2.84-2.16,1.04-3.95,5.24-3.23,7.6.39,1.29,1.56,2.15,2.97,2.19,1.44.04,2.57-.7,2.91-2.16.39-1.71.61-3.46.83-4.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle108);
export default __webpack_public_path__ + "static/media/twinkle-1-08.3eb43a30413c7733731aef2816e4ca08.svg";
export { ForwardRef as ReactComponent };